import { render, staticRenderFns } from "./VeHrPeixunApplyList.vue?vue&type=template&id=2257baa3&scoped=true"
import script from "./VeHrPeixunApplyList.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunApplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2257baa3",
  null
  
)

export default component.exports